import { defineComponent as _defineComponent } from 'vue'
import HtmlTemplate from '@/grpc-api/model/html-template';
import { PropType } from 'vue';
import HtmlImage from '@/components/util/HtmlImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateGridView',
  props: {
  templates: { type: Array as PropType<Array<HtmlTemplate>>, required: true },
  cardCols: { type: Number, required: false, default: 6 },
  cardColsSm: { type: Number, required: false, default: 4 },
  cardColsMd: { type: Number, required: false, default: 3 },
  cardColsLg: { type: Number, required: false, default: 2 },
  allowActions: { type: Boolean, required: false, default: false },
},
  emits: ["select-template", "edit-template", "duplicate-template", "delete-template", "rename-template"],
  setup(__props, { emit }: { emit: ({(e: 'select-template'|'edit-template'|'duplicate-template'|'delete-template'|'rename-template', templte: HtmlTemplate): void}), expose: any, slots: any, attrs: any }) {

const props = __props;



// eslint-disable-next-line vue/max-len


const selectTemplate = (t: HtmlTemplate) => {
  emit('select-template', t);
};

const editTemplate = (t: HtmlTemplate) => {
  emit('edit-template', t);
};

const duplicateTemplate = (t: HtmlTemplate) => {
  emit('duplicate-template', t);
};

const deleteTemplate = (t: HtmlTemplate) => {
  emit('delete-template', t);
};

const renameTemplate = (t: HtmlTemplate) => {
  emit('rename-template', t);
};


return { __sfc: true,props, emit, selectTemplate, editTemplate, duplicateTemplate, deleteTemplate, renameTemplate, HtmlImage }
}

})